<template>
    <div>
      <van-nav-bar
        title="推广账户"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/members')"

      />
      <van-cell-group>
        <van-cell title="佣金金额" :value="agent_account" is-link to="agency/agent_commission_details">
        </van-cell>
        <!-- <van-cell title="佣金金额">
          <template #default>
            <span>{{ agent_account }}</span>
          </template>
        </van-cell> -->
        <van-cell title="提取总额" :value="wit_total" is-link to="agency/agent_withdraw_details"/>
        <van-cell title="管理费总额" :value="manage_total" is-link to="agency/manage_cost"/>
        <van-cell title="递延费总额" :value="deferred_total" is-link to="agency/deferred_cost" />
        <van-cell title="利润分成总额" :value="divide_total" is-link to="agency/divided_cost"/>
        <van-cell title="会员充值奖励" :value="push_total" is-link to="agency/voucher_cost"/>
        <van-cell title="资金提现划转" is-link to="agency/agent_transfer_withdrawal"/>
        <!-- <van-cell title="资金提现" is-link to="agency/agency_withdrawal"/> -->
        <!-- <van-cell title="资金划转" is-link to="agency/agency_transfer"/> -->
        <van-cell title="推广链接" @click="resetSession()" is-link to="agency/agency_link"/>
        <van-cell title="我的团队" is-link to="agency/my_team"/>
      </van-cell-group>
    </div>
</template>

<script>
    export default {
      name: "Agency",
      data(){
        return{
          agent_account:'',
          manage_total:0,
          divide_total:0,
          deferred_total:0,
          push_total:0,
          wit_total:0,

        }
      },
      computed:{
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        resetSession() {
          sessionStorage.removeItem("couponCode");
        },
        getUser() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code === 1) {
                that.agent_account = resData.data.agent_account;
              } else if (res.data.code === 0 || res.data.code === -1) {
                that.$toast.fail(resData.msg);
              }
            });
        },
        getAgentAccount(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_account",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.deferred_total = resData.data.deferred_total;
                that.divide_total = resData.data.divide_total;
                that.manage_total = resData.data.manage_total;
                that.wit_total = resData.data.wit_total;
                that.push_total = resData.data.push_total;
              }else if (res.data.code == 0) {
                that.$toast.fail(res.data.msg);
              }
            });
        },

      },
      mounted:function () {
        this.isLogin();
        this.getUser();
        this.getAgentAccount();
      }
    }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Agency.vue